<template>
    <div class="operation-container" :class="{'single-btn': operationComponent.activityButtonList.length > 1, 'advertise': isAdvertise}" >
      <!-- <div class="operation-items"> -->
        <!-- 直接使用img标签显示背景图，不使用任何比例换算 -->
        <img v-if="operationComponent.backgroundImg" :class="{'advertise-bg': isAdvertise}" :src="operationComponent.backgroundImg" alt="" style="width: 100%; display: block;">
        <!-- <div v-else class="operation-img"></div> -->
        <!-- 内容元素叠加在背景图上 -->
        <div class="items-content">
          <div class="operation-item" v-for="(item, index) in operationComponent.activityButtonList" :key="item.jumpLink" @click="handleOperationClick(item, index)">
              <img :src="item.buttonImg" alt="">
          </div>
        </div>
      <!-- </div>   -->
    </div>
</template>
<script>
import wx from "weixin-js-sdk";
import { isWxMiniProgram } from "@/utils";
export default {
  name: 'Operation',
  components: {

  },
  props: {
    propData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isAdvertise: {
      type: Boolean,
      default: false
    },
    operationComponent: {
      type: Object,
      default: () => {
        // return {
        //   backgroundImg: require('@/assets/ticket/freeOrder/opera-bg.png'),
        //   activityButtonList: [
        //     {
        //       buttonImg: require('@/assets/ticket/freeOrder/opera-btn-1.png'),
        //       jumpLink: 'https://www.baidu.com',
        //     },
        //     {
        //       buttonImg: require('@/assets/ticket/freeOrder/opera-btn-2.png'),
        //       jumpLink: 'https://www.baidu.com',
        //     },
        //   ]
        // }
      }
    }
  },
  data() {
    return {
    }
  },
  mounted() {
    this.$sensors.track("mkt_couponClaim_actionBar_view", {
      activity_id: this?.propData?.activityNo || '',
      is_free_order: this.propData?.freeOrderActivity ? "是" : "否",
      btn_number: this.operationComponent?.activityButtonList?.length || 0
    });
  },
  computed: {
  },
  methods: {
    // 关注公众号
    // 在小程序内打开的H5中打开公众号H5
    toFollowOfficialAccount (url) {
      if (isWxMiniProgram()) {
        try {
          wx.miniProgram.navigateTo({
            url: '/packages/activity/activityView/activityView?auth=1&url=' + encodeURIComponent(url),
          })
        } catch (e) {
          window.open(url)
        }
      } else {
        window.open(url)
      }
    },
    handleOperationClick(item, index) {
      if (item.jumpLink.includes('http')) {
        this.toFollowOfficialAccount(item.jumpLink)
      } else if (isWxMiniProgram()) {
        // 跳转小程序
        wx.miniProgram.navigateTo({
          url: `/${item.jumpLink}`,
        })
      }
      this.$sensors.track("mkt_couponClaim_actionBar_click", {
        activity_id: this?.propData?.activityNo || '',
        is_free_order: this.propData?.freeOrderActivity ? "是" : "否",
        btn_index: index + 1
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.advertise {
  margin-bottom: 0 !important;
}
.single-btn {
  min-height: 152px !important;
}
.operation-container {
  margin-top: 32px;
  text-align: center;
  background-color: #fff;
  position: relative;
  margin-left: -24px;
  margin-right: -24px;
  min-height: 80px;
  margin-bottom: -32px;
  border-radius: 0 0 32px 32px;
  overflow: hidden;
  img {
    border-radius: 0 0 32px 32px;
    object-fit: cover;
  }
  .advertise-bg {
    border-radius: 0 !important;
  }
  .operation-title {
    font-size: 22px;
    color: #999;
    margin-bottom: 30px;
  }
  .items-content {
    position: absolute;
    left: 0;
    bottom: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
  }
  
  .operation-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
}
</style>